import { render, staticRenderFns } from "./DeskTasks.vue?vue&type=template&id=3a74c2b4"
import script from "./DeskTasks.vue?vue&type=script&lang=js"
export * from "./DeskTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports